'use client'

import { useEffect } from 'react'
import SiteError from '@/components/reference/SiteError'

export default function BlogsError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Blogs error:', error)
  }, [error])

  return (
    <SiteError
      error={error}
      reset={reset}
      title='Failed to load blog posts'
      message={
        "We couldn't load the blog posts. This might be a temporary issue. Please try again."
      }
      links={[{ href: '/', label: 'Go home' }]}
    />
  )
}
